<template>
	<div class="i-image-collection">
		<label>{{label}}</label>
		<div class="images row no-gutters">
			<div class="image-container col-sm-2" v-for="item in value">
				<div class="image" :style="{backgroundImage:`url(${item.src}?w=320)`}">
					<img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
					<btn t="d" i='trash' style='position:absolute;margin-top:-30px;' @press="remove(item)"/>
				</div>
			</div>
			<div class="image-container col-sm-2">
				<i-uploader :containerMode="true" @input="addImage">
					<div class="image-create">
						<div class="fa fa-plus" style=''></div>
						Добавить изображение
					</div>
				</i-uploader>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
export default {
  props:["label", "value"],
  name: 'i-image-collection',
  methods:{
  	addImage(img){
  		this.$emit("input",_.concat(this.value, {src:img, title:prompt("Название для изображения")}))
  	},
  	remove(item){
  		let newArr = this.value.filter(f=>{return f.src!==item.src});
  		this.$emit("input",newArr);
  	}
  },

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
.image{
	background-size: cover;
	background-position: center;
}
.image-create{
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 96%;
	width: 96%;
	border:2px dashed grey;
	cursor: pointer;
	margin:2%;
	padding:10px;
	box-sizing: border-box;
}
.image-create:hover{
	background: whitesmoke;
}
</style>